<form [formGroup]="form" class="m-form" novalidate>
    <ng-select class="select2" 
        [items]="data$ | async"
        bindLabel="name" 
        bindValue="id" 
        formControlName="id" 
        (change)="onSelect($event)"
        [groupBy]="groupByFn"
        [groupValue]="groupValueFn"
        [placeholder]="'classificacao.componente'  | translate" [notFoundText]="'geral.not-found' | translate">
        <ng-template ng-optgroup-tmp let-item="item">
            <span style="vertical-align: middle;">{{ item.name }} <small>{{ item.stage.name }}</small></span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <span>{{ item.name }}</span>
            <div *ngIf="!!item.knowledge_area"><small><em>{{ item.knowledge_area.name }}</em></small></div>
        </ng-template>
    </ng-select>
</form>